import { IsString, IsIn, IsNotEmpty, IsOptional } from 'class-validator';

import { Banner } from './banner.dto';

const notEmptyOptions = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class WidgetBannerDto {
  @IsString()
  @IsNotEmpty(notEmptyOptions)
  name: string;

  @IsString()
  @IsIn(['simple', 'construct'])
  @IsNotEmpty()
  type: 'simple' | 'construct';

  @IsOptional()
  slides: Banner[];
}
